export default __webpack_public_path__ + "static/media/DM_face.aec81dd0.png";